import React from 'react'
import { useState,useEffect } from 'react';
import { Box} from '@mui/material';

import { getAllBuilderCompanies, postNewBuildBranch } from '../../Services/BuilderAPI';

import AddBranchForm from '../../../Components/Branches/AddBranchForm';
import DialogeConfirmationBoxBranch from '../../../Components/Branches/DialogeBox/DialogeConfirmationBoxBranch';
import LoadingBackDrop from '../../../Components/LoadingBackDrop';
import SnackBar from '../../../Components/SnackBar';


export default function AddBuilderBranchForm() {

  let hqBusinessType = "Builder";
  let confirmationType = "Add";
  let titleAction = "Add";
  // let actionOn = "Branch";

  const [companiesArray, setCompaniesArray] = useState([]);

  const [inputStateValue, setInputStateValue] = React.useState('');
  const [stateValue, setStateValue] = React.useState(null);
  const [viewBranchFields, setViewBranchFields] = useState("none");

  const [confirmationDialogeBoxOpen, setConfirmationDialogeBoxOpen] = useState(false);
  const [openLoadingBackDrop, setOpenLoadingBackdrop] = useState(false);

  /**
   * SNACK BAR States
   */
  const[alertType,setAlertType] = useState("success");
  const[alertMessage, setAlertMessage]=useState("")
  const [snackBarOpen, setSnackBarOpen] = useState(false);
    
  const[branchObjct, setBranchObjct] = useState( {
    // branch_id:0,
    branch_name:"",
    company_association:{hq_id:""},
    branch_address:{
        address:"",
        address_two:"",
        city:"",
        state:"",
        zip:""
    },
    branch_phone:"",
    branch_email:"",
    branch_employees:[]
  })

  const [companyObjct, setCompanyObjct] = useState({
    hq_id:"",
    hq_company_name:"",
    hq_company_type:"Bank",
    hq_company_address:{
      address:"",
      address_two:"",
      city:"",
      state:"",
      zip:""
  },
    hq_phone:"",
    hq_email:""
  });


  const [errorObject,setErrorObject] = useState({
    branch_id:false,
    branch_name:false,
    company_association:{hq_id:""},
    branch_address:{
        address:false,
        addressTwo:false,
        city:false,
        state:false,
        zip:false
    },
    branch_phone:false,
    branch_email:false,
    branch_employees:[]

  });

  var initialCompanyObject = {
    hq_id:"",
    hq_company_name:"",
    hq_company_type:"Bank",
    hq_company_address:{
      address:"",
      address_two:"",
      city:"",
      state:"",
      zip:""
  },
    hq_phone:"",
    hq_email:""
  };

  let initialBranchObjct = {
    // branch_id:"",
    branch_name:"",
    company_association:{hq_id:""},
    branch_address:{
        address:"",
        address_two:"",
        city:"",
        state:"",
        zip:""
    },
    branch_phone:"",
    branch_email:"",
    branch_employees:[]
  };

  function handleConfirmDialogeBoxClose(){
    setConfirmationDialogeBoxOpen(false);
  };

  function handleLoadingClose(){
    setOpenLoadingBackdrop(false);
  };

  /**
   * OPENS THE SNACKBAR
   */
  const handleSnackBarOpen = () => {
    setSnackBarOpen(true);
  };

  /**
   * CLOSES THE SNACK BAR
   */
  const handleSnackBarClosed = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBarOpen(false);
  };

  useEffect(()=>{
    // get all the Builder Companies
    const fetchBuilderCompanies = async () => {
      const allBuilderCompaniesData = await getAllBuilderCompanies();
      console.log(allBuilderCompaniesData.data)
      setCompaniesArray(allBuilderCompaniesData.data);
      return allBuilderCompaniesData.data
    }
    fetchBuilderCompanies();
    
  },[]);



  function handleChoosenHQChange(e){
    
    let hq_id = e.target.value

    if(hq_id === null || hq_id === ""){
      setViewBranchFields("none");
      setBranchObjct(initialBranchObjct);
    }else{
      setViewBranchFields("block");
    }


    setBranchObjct({
        ...branchObjct,
        company_association:{
          ...branchObjct.company_association,
          hq_id:e.target.value
        }
      });
  };

  function handleNameChange(e){
    setBranchObjct({
      ...branchObjct,
      branch_name: e.target.value
    });
  };
  
  function handleEmailChange(e){
    setBranchObjct({
      ...branchObjct,
      branch_email: e.target.value
    });
  };
  
  function handlePhoneChange(e){
    setBranchObjct({
      ...branchObjct,
      branch_phone: e.target.value
    });
  };
  
  function handleAddressChange(e){
    setBranchObjct({
      ...branchObjct,
      branch_address:{
        ...branchObjct.branch_address,
        address:e.target.value
      }
    });
  };
  
  function handleAddressTwoChange(e){
    setBranchObjct({
      ...branchObjct,
      branch_address:{
        ...branchObjct.branch_address,
        address_two:e.target.value
      }
    });
  };
  
  function handleCityChange(e){
    setBranchObjct({
      ...branchObjct,
      branch_address:{
        ...branchObjct.branch_address,
        city:e.target.value
      }
    });
  };
  
  function handleStateChange(e){
    setBranchObjct({
      ...branchObjct,
      branch_address:{
        ...branchObjct.branch_address,
        state:e.index
      }
    });
  };
  
  function handleZipChange(e){
    setBranchObjct({
      ...branchObjct,
      branch_address:{
        ...branchObjct.branch_address,
        zip:e.target.value
      }
    });
  };

  /**
   * Error Validating The Form
   */
  function formErrorValidation(e){
    e.preventDefault();
    let foundError = false;

    if(branchObjct.branch_name === "" || branchObjct.branch_name === null ){
      setErrorObject({
        ...errorObject,
        branch_name:true
      });
      foundError = true;
    };

    if(!foundError){
      testConfirmAddCompanyConfirmationBox();
    }
  };

  /***
   * Handles the submit button from form component
   */
  function testConfirmAddCompanyConfirmationBox(){
    setConfirmationDialogeBoxOpen(true)
  };


  /***
   * Handles the response from the confirmation dialoge box
   */
  function dialogeConfirmationBoxAnswerHandle(resp){
    if(resp === "Agree"){
      setConfirmationDialogeBoxOpen(false);
      setOpenLoadingBackdrop(true);
      submitNewBranch();
    }else{
      setConfirmationDialogeBoxOpen(false);
    }
  }


  /***
   * Handles adding a new branch
   */
  async function submitNewBranch(){
    let resp = await postNewBuildBranch(branchObjct);
    if (resp.error){
      setAlertType("error");
      setAlertMessage(`There was an error ${titleAction}ing the ${hqBusinessType} Branch.`);
    }else{
      setAlertType("success");
      setAlertMessage(`The ${hqBusinessType} branch has been successfully added.`);
      handleSnackBarOpen();
      clearForm();
    }
    
  };

  function clearForm(){
    setCompanyObjct(initialCompanyObject);
    setBranchObjct(initialBranchObjct);
    setViewBranchFields("none");
    setOpenLoadingBackdrop(false);
  };


  return (
    <Box>
      <AddBranchForm
        errorValidator={errorObject}
        addWhatBranchTitle={hqBusinessType}
        addWhatCompanyTitle = {hqBusinessType}
        hqCompaniesToMap = {companiesArray}

        hqCompanyObject={companyObjct}
        branchObjct = {branchObjct}

        handleChoosenHQ = {handleChoosenHQChange} // HANDLES THE CHANGE OF THE SELECT HQ INPUT
        viewBranchFields={viewBranchFields}

        handleNameChange={handleNameChange}
        handleEmailChange={handleEmailChange}
        handlePhoneChange={handlePhoneChange}
        handleAddressChange={handleAddressChange}
        handleAddressTwoChange={handleAddressTwoChange}
        handleCityChange={handleCityChange}
        handleStateChange={handleStateChange}
        inputStateValue={inputStateValue}
        setInputStateValue={setInputStateValue}
        stateValue={stateValue}
        setStateValue={setStateValue}
        handleZipChange={handleZipChange}
        submitNewBranch={formErrorValidation}
      
      />
      <DialogeConfirmationBoxBranch
        confirmationType={confirmationType}
        titleAction={titleAction}

        addWhatCompanyType={hqBusinessType}
        hqCompanyObject={companyObjct}
        branchObject={branchObjct}
        confirmationDialogeBoxOpen={confirmationDialogeBoxOpen}
        dialogeConfirmationBoxAnswerHandle={dialogeConfirmationBoxAnswerHandle}
        handleConfirmDialogeBoxClose={handleConfirmDialogeBoxClose}
      />
      <LoadingBackDrop
        openLoadingBackDrop={openLoadingBackDrop}
        handleLoadingClose={handleLoadingClose}
      />
      <SnackBar
        handleSanckBarOpen={handleSnackBarOpen}
        handleSnackBarClosed={handleSnackBarClosed}
        snackBarState = {snackBarOpen}
        alertType={alertType}
        alertMessage={alertMessage}
      />
    </Box>
  )
}



